import { LANDING } from '@/constants/testIds';
import { SECTORS, SECTORS_OTHER } from '@/data/business';

const ROW_1 = [...SECTORS.slice(0, 6), SECTORS_OTHER.label];
const ROW_2 = SECTORS.slice(6);

const Chip = ({ children }) => (
    <span className="inline-flex items-center gap-3 px-5 sm:px-7 py-3 sm:py-4 font-display uppercase text-2xl sm:text-4xl tracking-wide whitespace-nowrap text-white">
        {children}
    </span>
);

export const Sectors = () => {
    return (
        <section
            id="sectors"
            data-testid={LANDING.sectors}
            className="relative py-20 sm:py-28 border-t border-white/5 overflow-hidden"
        >
            <div className="mx-auto max-w-[1400px] px-5 sm:px-8 mb-12 sm:mb-16">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
                    <div>
                        <span className="section-label">02 / Secteurs équipés</span>
                        <h2 className="mt-4 font-display uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.9] text-white">
                            Du BTP à la santé,
                            <br />
                            <span className="text-outline-yellow">tous les pros</span>
                        </h2>
                    </div>
                    <p className="max-w-md text-base sm:text-lg text-white leading-relaxed">
                        Chaque métier a ses contraintes et ses normes. MANU VET connaît les certifications EPI et les pièces qui durent vraiment sur le terrain — du chantier BTP au bloc opératoire.
                    </p>
                </div>
            </div>

            {/* Two marquee bands going OPPOSITE directions */}
            <div className="relative">
                <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10 pointer-events-none" />

                {/* Row 1 — defile vers la GAUCHE (default marquee) */}
                <div className="flex overflow-hidden border-y border-white/10 py-4 sm:py-5">
                    <div className="flex shrink-0 animate-marquee gap-2 sm:gap-3 pr-2 sm:pr-3">
                        {[...ROW_1, ...ROW_1].map((s, i) => (
                            <div key={`r1-${i}`} className="flex items-center gap-2 sm:gap-3">
                                <Chip>{s}</Chip>
                                <span className="inline-block h-2 w-2 bg-[#FFD500] rounded-full shrink-0" aria-hidden="true" />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Row 2 — defile vers la DROITE (reversed animation) */}
                <div className="flex overflow-hidden border-b border-white/10 py-4 sm:py-5">
                    <div
                        className="flex shrink-0 animate-marquee gap-2 sm:gap-3 pr-2 sm:pr-3"
                        style={{ animationDirection: 'reverse' }}
                    >
                        {[...ROW_2, ...ROW_2].map((s, i) => (
                            <div key={`r2-${i}`} className="flex items-center gap-2 sm:gap-3">
                                <span className="text-[#FFD500] font-display text-2xl sm:text-4xl">/</span>
                                <Chip>{s}</Chip>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
